<script lang="ts" setup>
import { MediaImageFragment, ParagraphAuthorSidebar } from '~/api/graphql/generated'
import { AuthorProps } from '../components/AuthorSidebar.vue'

const props = defineProps<{
  entity: ParagraphAuthorSidebar
}>()

const fieldAuthor = ref(props.entity.fieldAuthor?.entity)
const author: AuthorProps = {
  image: fieldAuthor?.value?.fieldPicture?.entity as MediaImageFragment,
  name: fieldAuthor?.value?.title ?? '',
  job: fieldAuthor?.value?.fieldJobTitle ?? '',
  email: fieldAuthor?.value?.fieldEmail ?? '',
  phone: fieldAuthor?.value?.fieldPhone ?? '',
}
</script>

<template>
  <AuthorSidebar v-if="fieldAuthor" :author="author" />
</template>
